export default __webpack_public_path__ + "static/badge-dont-2-bold-dark-fca61f68408a279977f7bd7c38977d52e9eeb3a1133f539e096e3d39d5af4d51.png";